const ACTION_TYPES = { UPDATE_WELCOME: 'UPDATE_WELCOME' };

const initialState = {};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE_WELCOME:
            return Object.assign({}, state, action.welcomeMat);

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
